import React, { useRef, useEffect, useImperativeHandle } from 'react';
import { useMap } from "../map";
import { usePropsReactive } from "../utils";
import { buildCreateOptions } from "../utils/control";
import { allProps, converterMap, setterMap } from "./config";
export var MapType = /*#__PURE__*/React.forwardRef(function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var ref = arguments.length > 1 ? arguments[1] : undefined;
  var _useMap = useMap(),
    map = _useMap.map,
    AMap = _useMap.AMap;
  var instanceObj = useRef(null);
  var _usePropsReactive = usePropsReactive(props, instanceObj, {
      setterMap: setterMap,
      converterMap: converterMap
    }),
    onInstanceCreated = _usePropsReactive.onInstanceCreated;
  useEffect(function () {
    if (map) {
      createInstance().then(function () {
        instanceObj.current.addTo(map);
        onInstanceCreated === null || onInstanceCreated === void 0 ? void 0 : onInstanceCreated(instanceObj.current);
      });
    }
  }, [map]);
  useImperativeHandle(ref, function () {
    return instanceObj.current;
  }, [instanceObj.current]);
  var createInstance = function createInstance() {
    return new Promise(function (resolve) {
      AMap.plugin(['AMap.MapType'], function () {
        var options = buildCreateOptions(props, allProps, converterMap);
        instanceObj.current = new AMap.MapType(options);
        resolve();
      });
    });
  };
  return null;
});